// Prominent, clearly-animated loading indicator (brand gradient ring + dots).
export function Spinner({ label = 'Loading' }) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16">
      <div
        className="h-12 w-12 animate-spin rounded-full"
        style={{
          background: 'conic-gradient(from 90deg, rgba(103,123,230,0) 0%, #8b9bf0 45%, #677BE6 80%, #7450A9 100%)',
          WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 0)',
          mask: 'radial-gradient(farthest-side, transparent calc(100% - 5px), #000 0)',
        }}
      />
      <div className="flex items-center text-sm font-medium text-slate-500 dark:text-slate-400">
        {label}
        <span className="ml-0.5 inline-flex">
          <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
          <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
        </span>
      </div>
    </div>
  );
}
